<template>
  <div>
    <vheader />
    <iframe :src="url" frameborder="0" id="show-iframe" style></iframe>
  </div>
</template>

<script>
import Vheader from "../header/VHeader";
export default {
  components: {
    Vheader
  },
  data() {
    return {
      classId: "",
      url: ""
    };
  },
  mounted() {
    this.frame();
  },

  watch: {
    classId: {
      handler() {
        this.showClass();
      }
    },
    $route: {
      deep: true,
      handler(val) {
        var url = location.href;
        var str = url.split("/");
        str = str.pop();
        this.classId = str;
      }
    }
  },
  metaInfo() {
    const metaMap = {
      "csjy.html": {
        meta: [
          {
            name: "keywords",
            content: "测试开发培训,博为峰51Testing,测试进阶"
          },
          {
            name: "description",
            content:
              "测试开发培训,是博为峰51Testing开办的软件测试工程师进阶课程,致力于提升学员的自动化测试和接口测试能力,培养学员的框架设计思想,并能灵活应用工具设计框架,以支撑团队测试自动化的实现."
          }
        ]
      },
      "cskf.html": {
        meta: [
          {
            name: "keywords",
            content: "测试开发培训,博为峰51Testing,测试进阶"
          },
          {
            name: "description",
            content:
              "测试开发培训,是博为峰51Testing开办的软件测试工程师进阶课程,致力于提升学员的自动化测试和接口测试能力,培养学员的框架设计思想,并能灵活应用工具设计框架,以支撑团队测试自动化的实现."
          }
        ]
      },
      "mcar.html": {
        meta: [
          {
            name: "keywords",
            content: "车载测试培训,博为峰51Testing,汽车测试"
          },
          {
            name: "description",
            content:
              "车载测试培训课程由深耕软件测试培训二十余年的博为峰推出，聚焦高端车载测试工程师岗位，依托新能源汽车产业红利与巨大人才缺口打造，面向零基础、转行、职场进阶三类人群，是一套集理论教学、设备实操、项目训练于一体的系统化就业培训课程."
          }
        ]
      },
      "neixun.html": {
        meta: [
          { name: "keywords", content: "软件测试,51Testing,企业内训" },
          {
            name: "description",
            content:
              "51Testing根据企业客户需求,个性化定制培训课程,帮助客户提高软件测试水平,业务开展数年来,已为上百家国内外知名企业提供了软件测试企业内训服务."
          }
        ]
      },
      "weipei.html": {
        meta: [
          { name: "keywords", content: "微培训,在线学习,技能提升" },
          { name: "description", content: "碎片化微培训，随时随地学习" }
        ]
      },
      "renzheng.html": {
        meta: [
          {
            name: "keywords",
            content: "博为峰51Testing,ISTQB认证,软件测试培训"
          },
          {
            name: "description",
            content:
              "博为峰51Testing联合国际认证机构共同为业内人士提供权威的软件测试认证服务——ISTQB（国际软件测试工程师认证）."
          }
        ]
      },
      "ruankaom.html": {
        meta: [
          { name: "keywords", content: "软考,计算机资格,职称考试" },
          {
            name: "description",
            content: "计算机技术与软件专业技术资格（水平）考试"
          }
        ]
      }
    };

    return (
      metaMap[this.classId] || {
        meta: [
          {
            name: "keywords",
            content: "博为峰,软件测试培训,51testing,就业培训"
          },
          {
            name: "description",
            content:
              "2004年起,博为峰51Testing在国内率先推出软件测试就业培训,累计开班3000+期,10万余名合格学员就业,其中已有上千名学员后晋升为测试经理,项目总监,成为软件测试领域的中坚力量."
          }
        ]
      }
    );
  },
  methods: {
    showClass() {
      console.log(this.classId);

      if (this.classId === "cskf.html") {
        this.url = "/static/cskf/index.html";
      } else if (this.classId === "renzheng.html") {
        this.url = "/static/istqb/index.html";
      } else if (this.classId === "csjy.html") {
        this.url = "/static/jypx/index.html";
      } else if (this.classId === "neixun.html") {
        this.url = "/static/tdnx/index.html";
      } else if (this.classId === "weipei.html") {
        this.url = "/static/wpzt/index.html";
      } else if (this.classId === "zhoumo.html") {
        this.url = "/static/zmjp/index.html";
      } else if (this.classId === "xueli.html") {
        this.url = "/static/zsb/index.html";
      } else if (this.classId === "ruankaom.html") {
        this.url = "/static/ruankao/index.html";
      } else if (this.classId === "python.html") {
        this.url = "/static/python/index.html";
      } else if (this.classId === "mcar.html") {
        this.url = "/static/car/mobile.html";
      }
    },
    frame() {
      var url = location.href;
      if (~url.indexOf("?")) {
        url = url.split("?")[0];
      }
      var str = url.split("/");
      str = str.pop();
      this.classId = str;
      const oIframe = document.getElementById("show-iframe");
      const deviceWidth = document.documentElement.clientWidth;
      const deviceHeight = document.documentElement.clientHeight;
      oIframe.style.width = deviceWidth + "px";
      oIframe.style.height = deviceHeight - 165 + "px";
      var frame = document.getElementById("show-iframe");
      frame.onload = function() {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS) {
          var iframebody = frame.contentWindow.document.body;
          iframebody.style.width = document.body.clientWidth + "px";
          iframebody.style.height = oIframe.style.height;
        }
      };
    }
  }
};
</script>

<style scoped>
iframe {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  min-width: 100%;
  *width: 100%;
  width: 1px;
  /* margin-bottom: 120px !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/classPage/ClassPage.vue